import { jsx as o } from "react/jsx-runtime";
function e(t) {
  return /* @__PURE__ */ o(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...t,
      children: /* @__PURE__ */ o(
        "path",
        {
          d: "M10.6667 6H1.33337M1.33337 6L6.00004 10.6667M1.33337 6L6.00004 1.33334",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
export {
  e as default
};
